<template>
<div>
    <!-- Home Start-->
    <section class="main-header bg-header value-based-care-banner-img">
        <div class="home-bg-img">
            <div class="container">
                <div>
                    <div class="item">
                        <div class="row align-items-center">
                            <div class="col-lg-7">
                                <div class="content wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                                    <h2 class="banner-title text-lg-left text-center text-white text-uppercase">
                                        VALUE-BASED CARE ASSESSMENT
                                    </h2>
                                    <p class="text-white text-lg-left text-center para-txt font-weight-medium f-16">
                                        <b class="sub-title">Value-Based Care Model is a profitable and sustainable strategy resulting in improved client care and satisfaction.</b><br><br>Tailored and consistent quality in care delivery is not just the responsibility of the direct care worker but instead, the participation and integration of the activities of all personnel involved in the continuum of care.
                                    </p>
                                </div>
                            </div>
                            <sales-lead-form product="Value Based Care Assessment"> </sales-lead-form>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>

    <section class="section services-top">
        <div class="container">
            <div class="services-main">
                <div class="row align-items-center">
                    <div class="col-md-12">
                        <img src="assets/images/assessments/value-based.png" alt="service-tab.png" class="w-100 img-fluid">
                    </div>

                    <div class="container">
                        <div data-wow-delay="0.6s" data-wow-duration="1s" class="about-bottom-section mt-5 wow fadeInUp" style="visibility: visible; animation-duration: 1s; animation-delay: 0.6s;">
                            <div class="col-md-12">
                                <img src="assets/images/assessments/value-based-care-info.png" alt="service-tab.png" class="w-100 img-fluid">
                            </div>
                            <!-- <div class="mt-12">
                                <div class="row align-items-center">
                                    <div class="col-lg-5"><img src="assets/images/assessments/health-care.png" alt="security.jpg" height="230" width="500"></div>
                                    <div class="col-lg-7 mt-lg-0 mt-4">
                                        <h1 class="font-sm-24">Anchor Value-Based Care Services</h1>
                                        <p class="m-0">
                                            <ul>
                                                <li>Value-Based Care Readiness Assessment</li>
                                                <li>Care Team Competency Assessment </li>
                                                <li>Customer Engagement & Survey Services </li>
                                                <li>Training & Professional Development</li>
                                            </ul>
                                        </p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>

                    <section class="section bg-light">
                        <div class="container">
                            <div class="row align-items-baseline">
                                <div class="col-lg-6 wow fadeInUp" data-wow-duration="1500ms">
                                    <div class="title-section">
                                        <div class="subtitle-hr d-flex align-items-center">
                                            <h6 class="subtitle theme-color text-uppercase position-relative">VALUE-BASED CARE ASSESSMENT</h6>
                                            <hr>
                                        </div>
                                        <h2 class="title text-md-left text-center f-30">What does this assessment involve?</h2>
                                    </div>
                                    <div class="mt-4">
                                        <div id="accordion" class="wow fadeInUp" data-wow-duration="1500ms">

                                            <div class="accordion-card bg-white mb-4 shadow rounded active">
                                                <div class="card-header border-0 p-0" id="headingOne">
                                                    <h5 class="mb-0">
                                                        <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne"><span class="font-weight-medium">
                                                                Anchor Value-Based Care Services
                                                            </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                                                    </h5>
                                                </div>
                                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                                    <div class="pt-2">
                                                        <p class="m-0">
                                                            <ul>
                                                                <li>Value-Based Care Readiness Assessment</li>
                                                                <li>Care Team Competency Assessment </li>
                                                                <li>Customer Engagement & Survey Services </li>
                                                                <li>Training & Professional Development</li>
                                                            </ul>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                                <div class="card-header border-0 p-0" id="headingTwo">
                                                    <h5 class="mb-0">
                                                        <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo"><span class="font-weight-medium">
                                                                Scoring Methodology
                                                            </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                                                    </h5>
                                                </div>
                                                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                                    <div class="pt-2">
                                                        <p class="m-0">
                                                            Our Value-Based Care Readiness Assessment contains over 100 questions and a scoring methodology that acknowledges and rewards businesses that continuously:
                                                            <ul>
                                                                <li>Plan</li>
                                                                <li>Measure</li>
                                                                <li>Learn </li>
                                                                <li>Refresh</li>
                                                            </ul>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                                <div class="card-header border-0 p-0" id="headingThree">
                                                    <h5 class="mb-0">
                                                        <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree"><span class="font-weight-medium">
                                                                Culture Shifting
                                                            </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                                                    </h5>
                                                </div>
                                                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                                    <div class="pt-2">
                                                        <p class="m-0">
                                                            Each organization making the shift to pay-for-value over volume model must revamp its posture towards care delivery—a culture shift at the executive level—setting the right tone at the top and advancing the overhauling of organizational strategy, business, and revenue models and KPIs.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                                <div class="card-header border-0 p-0" id="headingFour">
                                                    <h5 class="mb-0">
                                                        <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour"><span class="font-weight-medium">
                                                                Care Team Competency Assessment
                                                            </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                                                    </h5>
                                                </div>
                                                <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordion">
                                                    <div class="pt-2">
                                                        <p class="m-0">
                                                            Care Team Competency Assessment positions organizations to operationalize value-based behaviors through policies and procedures overhaul, revised staffing plans, and definition or redefinition of success at the functional level.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-12 text-left">
                                                    <button type="input" class="mt-4 btn theme-btn contact-form-btn border-0" value="Send" @click="download()">Get detailed pdf</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6 mt-lg-0 mt-6">
                                    <div class="wow fadeInUp" data-wow-duration="1500ms">
                                        <div class="title-section">
                                            <div class="subtitle-hr d-flex align-items-center">
                                                <h6 class="subtitle theme-color text-uppercase position-relative">Get started now</h6>
                                                <hr>
                                            </div>
                                            <h2 class="title text-md-left text-center f-20">Features</h2>
                                        </div>
                                    </div>
                                    <div class="mt-4 wow fadeInUp" data-wow-duration="1500ms">
                                        <img src="assets/images/assessments/value-based-features.png" alt="value-based-features.png" height="400">
                                        <br><br>
                                        <p><b>Whether you manage your population of full-time and part-time caregivers, nurses, caseworkers, community social workers, and other specialties, having the right structure, systems, tracking mechanisms, technology, and people in your HR function will make or break your organization.</b></p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>

                </div>
            </div>
        </div>
    </section>

    <!-- End Services Top -->

    <steps></steps>

    <section class="section bg-light">
        <div class="container">
            <div class="row align-items-baseline">
                <faqs></faqs>
                <assessment-listing></assessment-listing>
            </div>
        </div>
    </section>

    <promotions></promotions>
    <contact-form></contact-form>
</div>
</template>

<script>
//WOW JS
import {
    WOW
} from 'wowjs';
//OWL CAROUSEL JS
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

import SalesLeadForm from '../layouts/salesLeadForm.vue';
import ContactForm from '../layouts/contactForm.vue';
import AssessmentListing from '../layouts/assessmentListing.vue';
import Steps from '../layouts/steps.vue';
import Faqs from '../layouts/faqs.vue';
import Promotions from '../layouts/promotions.vue';

export default {
    name: 'index',
    selected: '',
    mounted() {
        this.init();
    },
    components: {
        SalesLeadForm,
        AssessmentListing,
        Steps,
        ContactForm,
        Promotions,
        Faqs,

    },
    methods: {
        init() {
            this.initMainSlider();
            this.initWowAnimation();
            this.initTeamSlider();
            this.initClientSlider();
            this.initAccordian();
        },
        download() {
            const url = 'assets/documents/VBC%20Assessment%20v4%2012.08.2022-compressed.pdf';
            //window.location.href = url;
            window.open(url, '_blank');
        },
        computed: {
            countries() {
                const list = countries.getNames('en', {
                    select: 'official'
                })
                return Object.keys(list).map((key) => ({
                    value: key,
                    label: list[key]
                }))
            }
        },
        /*----Main Slider----*/
        initMainSlider() {
            $('.main-slider').owlCarousel({
                loop: true,
                items: 1,
                margin: 0,
                nav: true,
                dots: true,
                autoplay: false,
                autoplayTimeout: 5000,
                items: 1,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: false,
                        dots: true
                    },
                    600: {
                        items: 1,
                        nav: false,
                        dots: true
                    },
                    1000: {
                        items: 1,
                        nav: false,
                        dots: true
                    }
                }
            });
        },
        /*----WOW ANIMATION-----*/
        initWowAnimation() {
            var length = $('.wow').length;
            if (length >= 1) {
                const wow = new WOW({
                    boxClass: 'wow',
                    animateClass: 'animated',
                    offset: 0,
                });
                wow.init();
            }
        },
        /*----TEAM SLIDER-----*/
        initTeamSlider() {
            var teamCarousel = $('.team-slider');
            if (teamCarousel.length > 0) {
                teamCarousel.owlCarousel({
                    loop: true,
                    items: 1,
                    margin: 0,
                    nav: true,
                    dots: true,
                    autoplay: false,
                    autoplayTimeout: 5000,
                    items: 2,
                    responsiveClass: true,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        600: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        991: {
                            items: 2,
                            nav: false,
                            dots: true
                        }
                    }
                });
            }
        },
        /*----CLIENT SLIDER-----*/
        initClientSlider() {
            var testimonialCarousel = $('.clients-slider');
            if (testimonialCarousel.length > 0) {
                testimonialCarousel.owlCarousel({
                    loop: true,
                    items: 1,
                    margin: 0,
                    nav: true,
                    dots: true,
                    autoplay: false,
                    autoplayTimeout: 5000,
                    items: 2,
                    responsiveClass: true,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        600: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        991: {
                            items: 2,
                            nav: false,
                            dots: true
                        }
                    }
                });
            }
        },
        /*----ACCORDIAN-----*/
        initAccordian() {
            $(".accordion-card").click(function () {
                if ($(this).hasClass('active')) {
                    $('.accordion-card').removeClass('active');
                    $(this).removeClass('active')
                } else {
                    $('.accordion-card').removeClass('active');
                    $(this).addClass('active')
                }
            });
        }
    }
}
</script>
